// JS for your graphic
import pym from "pym.js";
import * as d3 from "d3";
import sexData from "../data/data.csv"

const draw = async () => {
  // Access data and initialize figure:
  let getSexData = await d3.csv(sexData)

  getSexData = getSexData
    .filter(
      // Filter takes a function, and returns an array where that function
      // evaluates to true
      // e.g. [1, 2, 3, 4].filter(d => d % 2 === 0) -> [2, 4]
      (d) =>
        d["Q20"] != ""
    )

  const filteredDataNever = getSexData
    .filter(
      // Filter takes a function, and returns an array where that function
      // evaluates to true
      // e.g. [1, 2, 3, 4].filter(d => d % 2 === 0) -> [2, 4]
      (d) =>
        d["Q20"] === "Never"
    )


  let figureWidth = 500;
  if (figureWidth > window.innerWidth) {
    figureWidth = d3.select("figure").node().clientWidth;
  }

  if (figureWidth > window.innerWidth - 200) {
    figureWidth = window.innerWidth;
  }

  let figureHeight = 500;
  let margin = { "top": 10, "bottom": 100, "left": 40, "right": 20 }
  let xScale = d3.scaleBand().range([margin.left, figureWidth - margin.right]);;
  let yScale = d3.scaleLinear().range([0, 100]).domain(100);

  let xLabels = ["Never", "Once or twice per month or less", "Once or twice per week", "3-4 times per week", "5-6 times per week", "7+ times per week"];
  xScale.domain(xLabels)
    .padding(0.3)
  yScale.range([figureHeight - margin.bottom, margin.top]).domain([0, 45])

  // step 3: draw canvas
  let figure = d3.select("figure").append("svg")
    .attr("width", figureWidth).attr("height", figureHeight);

  figure.append("g")
    .attr("transform", `translate(${margin.left}, 0)`)
    .call(d3.axisLeft(yScale).tickFormat(function (d) {
      return d + "%";
    }).ticks(10));


  let sexDataDict = d3.rollup(getSexData, g => g.length / d3.selectAll(getSexData).size() * 100, d => d.Q20);

  figure.append("g")
    /*
    This is where the x-axis is placed (the translation is the 
    placement coordinate.
    */
    .attr("transform", `translate(0, ${figureHeight - margin.bottom})`)
    .call(d3.axisBottom(xScale))
    .selectAll("text")
    .attr("text-anchor", "end")
    .attr("transform", `translate(15,0)rotate(-20)`)

  figure.selectAll("rect").data(getSexData)
    .enter()
    .append("rect")
    .attr("y", function (d) {
      return yScale(sexDataDict.get(d.Q20));
    })
    .attr("x", function (d) { return xScale(d.Q20); })
    .attr("width", xScale.bandwidth())
    .attr("height", function (d) { return (figureHeight - margin.bottom) - yScale(sexDataDict.get(d.Q20)); })
    .attr("fill", "rgb(240, 101, 165)");
};

window.onload = () => {
  const pymChild = new pym.Child({ polling: 500 });
  pymChild.sendHeight();

  draw();

};
